import { values } from './enums'

const _enum = {
  ClassicHeader: 1,
  BottomHeader: 2,
  SandwichHeader: 3,
  LineHeader: 4
}

export const reportHeaderType = {
  enumName: 'ReportHeaderType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportHeaderType.js